"use client";
// Imports
import { MobileNavDrawer, MobileNav } from "@/components";

export function MobileMenu({ data, showDates }) {
  // Variables

  return (
    <MobileNavDrawer direction="bottom">
      <MobileNav showDates={showDates} data={data} />
    </MobileNavDrawer>
  );
}
